<template>
    <div>
        <p>他社サービスのアカウントを利用して{{ $locale.appName }}へログインしたい場合は、外部アカウント連携を行ってください。</p>
        <div class="socialItemWrapper d-flex justify-content-between align-items-center">
            <div class="socialItemName">
                <span>LINE</span>
                <span v-if="isAssociatedLine">&nbsp;<b-icon-check-circle-fill/>&nbsp;連携済み</span>
            </div>
            <div class="loginButtonWrapper">
                <b-button
                    v-if="isAssociatedLine"
                    variant="yokumiru-gray"
                    class="loginButton"
                    @click="onClickDetachAccount('line')"
                    :disabled="inProgress">
                    連携解除
                </b-button>
                <b-button
                    v-else
                    variant="yokumiru-user"
                    class="loginButton"
                    href="/social/oauth/redirect/line?is_association=1"
                    :disabled="inProgress">
                    アカウントを連携
                </b-button>
            </div>
        </div>
        <div class="socialItemWrapper d-flex justify-content-between align-items-center">
            <div class="socialItemName">
                <span>Apple</span>
                <span v-if="isAssociatedApple">&nbsp;<b-icon-check-circle-fill/>&nbsp;連携済み</span>
            </div>
            <div class="loginButtonWrapper">
                <b-button
                    v-if="isAssociatedApple"
                    variant="yokumiru-gray"
                    class="loginButton"
                    @click="onClickDetachAccount('apple')"
                    :disabled="inProgress">
                    連携解除
                </b-button>
                <b-button
                    v-else
                    variant="yokumiru-user"
                    class="loginButton"
                    href="/social/oauth/redirect/apple?is_association=1"
                    :disabled="inProgress">
                    アカウントを連携
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../constants'

export default {
    data: function () {
        return {
            user: null,
            inProgress: false,
        }
    },

    computed: {
        isAssociatedLine: function () {
            return this.user && this.user.user_social_accounts.some((socialAccount) => {
                return socialAccount.provider === constants.socialOauthProvider.line
            })
        },

        isAssociatedApple: function () {
            return this.user && this.user.user_social_accounts.some((socialAccount) => {
                return socialAccount.provider === constants.socialOauthProvider.apple
            })
        },
    },

    created: function () {
        bus.$on('fetched-user-account', this.initUser)
    },

    mounted: function () {
        //
    },

    methods: {
        initUser: function (user) {
            this.user = user
        },

        /**
         * 連携解除
         * @param {string} provider
         */
        onClickDetachAccount: async function (provider) {
            if (this.inProgress) return
            this.inProgress = true

            await axios.delete(`${constants.user.social.endpoint.base}/${provider}`)
                .then(() => {
                    bus.$emit('detached-user-social-account')
                    bus.$emit('alert-success', '連携を解除しました。')
                })
                .catch(({response}) => {
                    if (
                        response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors') &&
                        response.data.errors.hasOwnProperty('message')
                    ) {
                        this.errors = {}
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.socialItemWrapper {
    width: 90%;
    margin: 0 auto;
    padding: 15px 10px;
    border-bottom: 1px solid #dfdfdf;

    @media screen and (max-width:640px) {
        width: 100%;
    }

    &:last-child {
        border-bottom: none;
    }

    .socialItemName {
        color: #333;

        span {
            &:nth-child(1) {
                font-weight: bold;
            }

            &:nth-child(2) {
                color: #2cc561;
                font-size: 12px;

                svg {
                    fill: #2cc561;
                }
            }
        }
    }
}

/**
 * loginButton
 */
.loginButtonWrapper {
    width: 152px;

    a {
        line-height: 27px;
    }

    .loginButton {
        display: block;
        width: 100%;
        height: 40px;
        text-decoration: none;
        border-radius: 4px;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out
    }

    .loginButton:hover {
        text-decoration: none;
    }

    .loginButtonText {
        padding-left: 20px;
        color: #fff;
        font-size: 14px;
    }
}
</style>
